import React, { ReactNode } from 'react';
import { Sparkles } from 'lucide-react';
import '../AiBrunixPanel.css';

interface SystemMessageProps {
  children: ReactNode;
}

export const SystemMessage = ({ children }: SystemMessageProps) => {
  return (
    <div className="ai-brunix-panel-system-msg">
      <div className="ai-brunix-panel-msg-header">
        <Sparkles size={12} className="ai-brunix-panel-msg-icon" />
        <span className="ai-brunix-panel-msg-title">System_Message</span>
      </div>
      <div className="ai-brunix-panel-msg-text">
        {children}
      </div>
    </div>
  );
};
